module.exports = __webpack_public_path__ + "static/media/sketch_3.379a0afa.jpg";